<form [formGroup]="exportSettingsForm">
  <div class="export-settings-container">
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          Export Settings&nbsp;
          <fa-icon icon="info-circle" class="info-icon"></fa-icon>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content class="settings-card-content mat-elevation-z3">
        <div>
          <mat-button-toggle-group
            formControlName="isSchoolGroupLevel"
            class="button-toggle-group group-level-toggle"
            [class.hidden]="!isGroupLevelUser">
            <mat-button-toggle [value]="true">Group Level</mat-button-toggle>
            <mat-button-toggle *ngIf="!!user.currentSchoolId" [value]="false">School Level</mat-button-toggle>
          </mat-button-toggle-group>
          <mat-form-field class="full-width-input">
            <mat-label>File Name</mat-label>
            <input formControlName="fileName" matInput />
          </mat-form-field>
          <mat-form-field class="full-width-input">
            <mat-select
              formControlName="fileDelimiter"
              placeholder="Select Delimiter">
              <mat-option
                *ngFor="let delimiter of delimiters"
                [value]="delimiter.value">
                {{ delimiter.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width-input">
            <mat-chip-grid #chipGrid aria-label="Enter emails">
              <mat-chip-row
                *ngFor="let email of contactEmails"
                (removed)="removeEmail(email)"
                [editable]="true"
                (edited)="editEmail(email, $event)"
                [aria-description]="'press enter to edit ' + email.address">
                {{email.address}}
                <button
                  matChipRemove
                  [attr.aria-label]="'remove ' + email.address">
                  <fa-icon icon="times">Cancel</fa-icon>
                </button>
              </mat-chip-row>
              <input
                placeholder="New email address..."
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addEmail($event)" />
            </mat-chip-grid>
          </mat-form-field>
          <mat-checkbox
            formControlName="includeHeader"
            class="full-width-input"
            color="primary">
            Include Column Headers
          </mat-checkbox>
          <ng-container *ngIf="sftpAccounts && sftpAccounts.length > 0 && exportSettings.isSchoolGroupLevel !== undefined ">
            <mat-chip-option class="account-chip" color="primary" selected>
              SFTP Account Found</mat-chip-option
            >
          </ng-container>
          <ng-container *ngIf="sftpAccounts && sftpAccounts.length === 0 && exportSettings.isSchoolGroupLevel !== undefined ">
            <button
              class="new-account-button standard-button"
              mat-flat-button
              color="primary"
              (click)="createNewAccount()">
              Create New SFTP Account
            </button>
          </ng-container>
        </div>
        <div>
          <mat-form-field class="full-width-input">
            <mat-label>Export Type</mat-label>
            <mat-select
              formControlName="exportType"
              placeholder="Export Type"
              (selectionChange)="exportTypeChanged($event)">
              <ng-container *ngFor="let exportType of exportTypes | keyvalue">
                <mat-option
                  *ngIf="isIncidentsEnabled || exportType.key.toLowerCase() !== 'incidents'"
                  [value]="exportType.key">
                  {{ exportType.value }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width-input">
            <mat-label>Select Schools</mat-label>
            <mat-select multiple formControlName="schoolIds">
              <mat-option
                *ngFor="let school of schoolsOptions"
                [value]="school.value"
                options-id="schools"
                [option]="constantize(school.display)">
                {{school.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width-input" *ngIf="isIncidentExport()">
            <mat-label>Select Incident Types</mat-label>
            <mat-select multiple formControlName="incidentTypeIds">
              <mat-option
                *ngFor="let incidentTypeOption of incidentTypeOptions"
                [value]="incidentTypeOption.value"
                options-id="incidentTypes"
                [option]="constantize(incidentTypeOption.display)">
                {{incidentTypeOption.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            class="full-width-input"
            *ngIf="isBehaviorCodeExport() && schoolsSelected && !!behaviorCodeOptions?.length">
            <mat-label>Select Codes</mat-label>
            <mat-select multiple formControlName="behaviorCodeIds">
              <mat-option
                *ngFor="let behaviorCodeOption of behaviorCodeOptions"
                [value]="behaviorCodeOption.value"
                options-id="behaviorCodes"
                [option]="constantize(behaviorCodeOption.display)">
                {{behaviorCodeOption.display}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width-input">
            <mat-label>Record Options</mat-label>
            <mat-select
              matTooltip="•Choose “Only New” to export all records added since the last time this specific export was run. 
              
                          •Choose “Today’s Records” to export all records available from the selected day."
              matTooltipPosition="above"
              matTooltipClass="record-options-tooltip"
              formControlName="exportCodeTimeFilter"
              placeholder="Record Options"
              (selectionChange)="exportRecordOptionsChanged($event)">
              <mat-option
                *ngFor="let time of exportCodeTimes | keyvalue"
                [value]="time.key">
                {{ time.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="!dateRangeExport">
          <mat-form-field class="full-width-input" float>
            <mat-label>Export Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              formControlName="startDate" />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="full-width-input">
            <mat-select
              formControlName="exportInterval"
              placeholder="Export Interval">
              <mat-option
                *ngFor="let frequency of exportFrequencies"
                [value]="frequency">
                {{ frequency | enumString }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <app-utc-time-input
            placeholder="Export Time"
            class="full-width-input"
            *ngIf="showTime()"
            [date]="exportSettings.startDate"
            formControlName="exportTime"
            [displayTimezone]="timezone"
            [onBlur]="onBlurTime.bind(this)"
            >
          </app-utc-time-input>
          <div formArrayName="additionalRuntimes" *ngIf="showTime()">
            <ng-container  *ngFor="let runtime of additionalRuntimesFields.controls; let i = index">
              <div class="additional-runtime">
              <app-utc-time-input
                placeholder="Additional Export Time"
                class="full-width-input"
                [displayTimezone]="timezone"
                [date]="exportSettings.startDate"
                [formControlName]="i"
              >
              </app-utc-time-input>
                <fa-icon class="fa-duotone fa-solid fa-circle-xmark" (click)="removeRuntimeField(i)"[icon]="['fas', 'circle-xmark']"></fa-icon> 
              </div>
            </ng-container>
          </div>
          
           <button
              *ngIf="shouldDisplayAddExportTimeButton()"
              mat-flat-button
              class="dashed-border-button"
              matTooltip="Export multiple times on the selected day(s)."
              matTooltipPosition="above"
              (click)="addRuntimeField()">
              <fa-icon [icon]="['fas', 'plus']"></fa-icon>
              
              Add export time
           </button>


          <div class="form-row" *ngIf="showStartEndTime()">
            <app-utc-time-input
              placeholder="Start Time"
              class="half-width-input"
              [date]="exportSettings.startDate"
              formControlName="exportTime"
              [displayTimezone]="timezone"
              [onBlur]="onBlurTime.bind(this)">
            </app-utc-time-input>
            <app-utc-time-input
              placeholder="End Time"
              class="half-width-input"
              [date]="exportSettings.startDate"
              formControlName="exportEndTime"
              [displayTimezone]="timezone"
              [onBlur]="onBlurTime.bind(this)">
            </app-utc-time-input>
          </div>
          <mat-form-field class="full-width-input" *ngIf="showDays()">
            <mat-select
              formControlName="exportDays"
              placeholder="Select Days of the Week"
              multiple>
              <mat-option *ngFor="let type of weekDays" [value]="type.value">
                {{type.label}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="dateRangeExport">
          <mat-form-field class="full-width-input" float>
            <mat-label>Export From This Date</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              formControlName="exportStartDate" />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="full-width-input" float>
            <mat-label>Export To This Date</mat-label>
            <input
              matInput
              [matDatepicker]="endPicker"
              formControlName="exportEndDate" />
            <mat-datepicker-toggle
              matSuffix
              [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </mat-card-content>
      
    </mat-card>
    
  </div>
         
  <div class="twoColumnLayout">
    <div class="column">
      <div class="header">Build Your Export</div>
    </div>
    <div class="column">
      <div class="mapping-action-buttons">
        <button
          mat-flat-button
          class="standard-button"
          color="primary"
          [matBadge]="formErrors.length"
          [matBadgeHidden]="formErrors.length === 0"
          [matBadgeColor]="'warn'"
          (click)="runExport()">
          Save & Run Now
        </button>
        <button
          class="standard-button import-button"
          mat-flat-button
          (click)="saveSettings()">
          Save Export
        </button>
      </div>
    </div>
  </div>
  <ng-container>
    <app-export-builder
      [fieldList]="exportFieldList"
      [exportFieldsConfig]="exportFieldsConfig"
      [exportType]="exportSettings.exportType"
      (onExportFieldsChange)="updateExportFields($event)"></app-export-builder>
  </ng-container>
</form>
